import {
    SET_SPINNER_STATUS
} from '../../actions';

const initialState = {
    boolean: false
}

function spinnerReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_SPINNER_STATUS:
            newState.boolean = action.status;
            return newState;
        
        default:
            return state;

    }
 
}

export default spinnerReducer;
